/**
 * Wrapper for WBReactTable for consistent styling
 * Similar to Launch/Table.tsx
 */

import {
  MOON_250,
  MOON_500,
  TEAL_500,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import WBReactTable from '../../WBReactTable';

export const Table = styled(WBReactTable)<{
  border?: string;
}>`
  margin-bottom: 0;
  border: ${p => p.border ?? `1px solid ${MOON_250}`};

  .searchbox .wbic-ic-search {
    color: ${MOON_500};
  }
  a {
    font-weight: 600;
    color: ${TEAL_600} !important;
    &:hover {
      color: ${TEAL_500} !important;
    }
  }
  .rt-tr-group {
    .visible-on-hover {
      visibility: hidden;
    }
    &:hover .visible-on-hover {
      visibility: visible;
    }
  }
`;
Table.displayName = 'S.Table';
